let PORT_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const API_CONST = Object.freeze({
    BASE_URL: PORT_URL + "/api",
    LOGIN: PORT_URL + "/api/login",
    SIGNUP: PORT_URL + "/api/signup",
    ADD_USER_MANAGEMENT: PORT_URL + "/api/add-user-management",
    GET_USER_MANAGEMENT: PORT_URL + "/api/get-user-management",
    GET_USER: PORT_URL + "/api/get-user",
    GET_USER_FILTER_OPTIONS: PORT_URL + "/api/get-user-filter-options",
    UPDATE_USER_MANAGEMENT: PORT_URL + "/api/update-user-management",
    DELETE_USER_MANAGEMENT: PORT_URL + "/api/delete-user-management",
    CHANGE_PASSWORD: PORT_URL + "/api/change-password",
    BULK_STATUS_CHANGE: PORT_URL + "/api/bulk-status-change",
    ADD_TALENT_PROFILE: PORT_URL + "/api/add-talents-profiles",
    GET_TALENT_PROFILES: PORT_URL + "/api/get-talents-profiles",
    GET_TALENT_PROFILE: PORT_URL + "/api/get-talent-profile",
    UPDATE_TALENT_PROFILE: PORT_URL + "/api/update-talent-profile",
    DELETE_TALENT_PROFILE: PORT_URL + "/api/delete-talent-profile",
    UPDATE_TALENT_STATUS: PORT_URL + "/api/update-talent-status",
    BULK_TALENT_STATUS_CHANGE: PORT_URL + "/api/bulk-talent-status-change",
    GET_PARTNER_ORGANIZATIONS: PORT_URL + "/api/get-partner-organizations",
    GET_CUSTOMER_ORGANIZATIONS: PORT_URL + "/api/get-customer-organizations",
    ADD_JOB_REQUIREMENTS: PORT_URL + "/api/add-job-requirements",
    GET_JOB_REQUIREMENTS: PORT_URL + "/api/get-job-requirements",
    GET_JOB_REQUIREMENT: PORT_URL + "/api/get-job-requirement",
    UPDATE_JOB_REQUIREMENT: PORT_URL + "/api/update-job-requirement",
    DELETE_JOB_REQUIREMENT: PORT_URL + "/api/delete-job-requirement",
    UPDATE_JOB_STATUS: PORT_URL + "/api/update-job-status",
    GET_JOB_FILTER_OPTIONS: PORT_URL + "/api/get-job-filter-options",
    GET_MY_PROFILE: PORT_URL + "/api/get-my-profile",
    UPDATE_MY_PROFILE: PORT_URL + "/api/update-my-profile",
    CHANGE_MY_PASSWORD: PORT_URL + "/api/change-my-password",
    UPLOAD_REQUEST_URL: PORT_URL + "/api/uploads/request-url",
    GET_DOCUMENT_URL: PORT_URL + "/api/get-document-url",
    GET_GLOBAL_SETTINGS: PORT_URL + "/api/get-global-settings",
    UPDATE_GLOBAL_SETTINGS: PORT_URL + "/api/update-global-settings",
    SUBMIT_PROFILES_TO_JOB: PORT_URL + "/api/submit-profiles-to-job",
    GET_JOB_APPLICATIONS: PORT_URL + "/api/get-job-applications",
    UPDATE_JOB_APPLICATION: PORT_URL + "/api/update-job-application",
    WITHDRAW_JOB_APPLICATION: PORT_URL + "/api/withdraw-job-application",
    GET_EMAIL_SETTINGS: PORT_URL + "/api/get-email-settings",
    UPDATE_EMAIL_SETTINGS: PORT_URL + "/api/update-email-settings",
    ADD_HIRING_RECORD: PORT_URL + "/api/add-hiring-record",
    GET_HIRING_RECORDS: PORT_URL + "/api/get-hiring-records",
    GET_HIRING_RECORD: PORT_URL + "/api/get-hiring-record",
    UPDATE_HIRING_RECORD: PORT_URL + "/api/update-hiring-record",
    DELETE_HIRING_RECORD: PORT_URL + "/api/delete-hiring-record",
    TERMINATE_HIRING_RECORD: PORT_URL + "/api/terminate-hiring-record",
    ACTIVATE_HIRING_RECORD: PORT_URL + "/api/activate-hiring-record",
    GET_TALENT_JOB_APPLICATIONS: PORT_URL + "/api/get-talent-job-applications",
    PARSE_RESUME: PORT_URL + "/api/parse-resume",
    RESUME_SAMPLE_TEMPLATE: PORT_URL + "/api/parse-resume/sample-template",
    GET_WORK_SETTINGS: PORT_URL + "/api/get-work-settings",
    UPDATE_WORK_SETTINGS: PORT_URL + "/api/update-work-settings",
    GET_ORG_WORK_SETTINGS: PORT_URL + "/api/get-org-work-settings",
    ADD_ORG_WORK_SETTINGS: PORT_URL + "/api/add-org-work-settings",
    UPDATE_ORG_WORK_SETTINGS: PORT_URL + "/api/update-org-work-settings",
    DELETE_ORG_WORK_SETTINGS: PORT_URL + "/api/delete-org-work-settings",
    GET_EFFECTIVE_WORK_SETTINGS: PORT_URL + "/api/get-effective-work-settings",
    GENERATE_TIMESHEETS: PORT_URL + "/api/generate-timesheets",
    GET_TIMESHEETS: PORT_URL + "/api/get-timesheets",
    GET_TIMESHEET: PORT_URL + "/api/get-timesheet",
    TIMESHEET_UPLOAD_REQUEST_URL: PORT_URL + "/api/timesheets/upload-request-url",
    SUBMIT_TIMESHEET: PORT_URL + "/api/submit-timesheet",
    VERIFY_TIMESHEET: PORT_URL + "/api/verify-timesheet",
    APPROVE_TIMESHEET: PORT_URL + "/api/approve-timesheet",
    REJECT_TIMESHEET: PORT_URL + "/api/reject-timesheet",
    UPDATE_TIMESHEET: PORT_URL + "/api/update-timesheet",
    DELETE_TIMESHEET: PORT_URL + "/api/delete-timesheet",
    SHARE_TIMESHEET: PORT_URL + "/api/share-timesheet",
    GET_TIMESHEET_DOWNLOAD_URL: PORT_URL + "/api/get-timesheet-download-url",
    SYNC_NOW: PORT_URL + "/api/sync-now",
    GET_INVOICES: PORT_URL + "/api/get-invoices",
    GET_INVOICE: PORT_URL + "/api/get-invoice",
    UPDATE_INVOICE_STATUS: PORT_URL + "/api/update-invoice-status",
    REQUEST_INVOICE_MODIFICATION: PORT_URL + "/api/invoices",
    GET_INVOICE_SUMMARY: PORT_URL + "/api/get-invoice-summary",
    SUBMIT_PARTNER_INVOICE: PORT_URL + "/api/submit-partner-invoice",
    SUBMIT_CUSTOMER_INVOICE: PORT_URL + "/api/submit-customer-invoice",
    INVOICE_UPLOAD_REQUEST_URL: PORT_URL + "/api/invoices/upload-request-url",
    INVOICE_DOWNLOAD_URL: PORT_URL + "/api/invoices/download-url",
    REVENUE_ANALYSIS: PORT_URL + "/api/revenue-analysis",
    FINANCIAL_INSIGHTS: PORT_URL + "/api/financial-insights",
    GET_AUTOMATION_SETTINGS: PORT_URL + "/api/get-automation-settings",
    UPDATE_AUTOMATION_SETTINGS: PORT_URL + "/api/update-automation-settings",
    CREATE_ORGANIZATION: PORT_URL + "/api/create-organization",
    GET_ORGANIZATION: PORT_URL + "/api/get-organization",
    GET_ORGANIZATION_BY_NAME: PORT_URL + "/api/get-organization-by-name",
    GET_ORGANIZATIONS: PORT_URL + "/api/get-organizations",
    UPDATE_ORGANIZATION: PORT_URL + "/api/update-organization",
    UPDATE_ORGANIZATION_BY_NAME: PORT_URL + "/api/update-organization-by-name",
    GET_MY_ORGANIZATION: PORT_URL + "/api/get-my-organization",
    UPDATE_MY_ORGANIZATION: PORT_URL + "/api/update-my-organization",
    CHECK_PROFILE_COMPLETION: PORT_URL + "/api/check-profile-completion",
    CREATE_ENGAGEMENT: PORT_URL + "/api/engagement/create",
    GET_ENGAGEMENTS: PORT_URL + "/api/engagement/list",
    GET_ENGAGEMENT: PORT_URL + "/api/engagement",
    UPDATE_ENGAGEMENT: PORT_URL + "/api/engagement",
    APPROVE_ENGAGEMENT: PORT_URL + "/api/engagement",
    REQUEST_ENGAGEMENT_CLOSURE: PORT_URL + "/api/engagement",
    CLOSE_ENGAGEMENT: PORT_URL + "/api/engagement",
    REJECT_ENGAGEMENT_CLOSURE: PORT_URL + "/api/engagement",
    DELETE_ENGAGEMENT: PORT_URL + "/api/engagement",
    GET_ENGAGEMENT_STATS: PORT_URL + "/api/engagement/stats",
    GET_ACTIVE_ENGAGEMENTS: PORT_URL + "/api/engagement/active",
    CREATE_PROJECT: PORT_URL + "/api/project/create",
    GET_PROJECTS: PORT_URL + "/api/project/list",
    GET_PROJECT: PORT_URL + "/api/project",
    UPDATE_PROJECT: PORT_URL + "/api/project",
    APPROVE_PROJECT: PORT_URL + "/api/project",
    REJECT_PROJECT: PORT_URL + "/api/project",
    COMPLETE_PROJECT: PORT_URL + "/api/project",
    GET_PROJECT_STATS: PORT_URL + "/api/project/stats",
    GET_ACTIVE_PROJECTS: PORT_URL + "/api/project/active",
    GET_PROJECT_RECOMMENDATIONS: PORT_URL + "/api/project",
    CREATE_DRAFT_JOBS: PORT_URL + "/api/project",
    GENERATE_JD: PORT_URL + "/api/project/generate-jd",
    GET_GENERATED_JD: PORT_URL + "/api/project/generated-jd",
    GET_PROJECT_GENERATED_JDS: PORT_URL + "/api/project",
    CREATE_AI_PROJECT_ASSESSMENT: PORT_URL + "/api/ai-assessment/create",
    GET_AI_PROJECT_ASSESSMENTS: PORT_URL + "/api/ai-assessment/list",
    GET_AI_PROJECT_ASSESSMENT: PORT_URL + "/api/ai-assessment",
    RETRY_AI_PROJECT_ASSESSMENT: PORT_URL + "/api/ai-assessment",
    GET_AI_ASSESSMENT_STATS: PORT_URL + "/api/ai-assessment/stats",
    CREATE_ISSUE_FEEDBACK: PORT_URL + "/api/issue-feedback/create",
    GET_ISSUE_FEEDBACK_LIST: PORT_URL + "/api/issue-feedback/list",
    GET_ISSUE_FEEDBACK: PORT_URL + "/api/issue-feedback",
    UPDATE_ISSUE_FEEDBACK: PORT_URL + "/api/issue-feedback",
    DELETE_ISSUE_FEEDBACK: PORT_URL + "/api/issue-feedback",
    GET_ISSUE_FEEDBACK_STATS: PORT_URL + "/api/issue-feedback/stats",
    ACKNOWLEDGE_ISSUE_FEEDBACK: PORT_URL + "/api/issue-feedback/:id/acknowledge",
    
    CREATE_PERMISSION: PORT_URL + "/api/permission/create-permission",
    UPDATE_PERMISSION: PORT_URL + "/api/permission/update-permission",
    DELETE_PERMISSION: PORT_URL + "/api/permission/delete-permission",
    GET_PERMISSION: PORT_URL + "/api/permission/get-permission",
    GET_PERMISSIONS: PORT_URL + "/api/permission/get-permissions",
    GET_PERMISSION_MODULES: PORT_URL + "/api/permission/get-permission-modules",
    
    CREATE_PROFILE_ROLE: PORT_URL + "/api/permission/create-profile-role",
    UPDATE_PROFILE_ROLE: PORT_URL + "/api/permission/update-profile-role",
    DELETE_PROFILE_ROLE: PORT_URL + "/api/permission/delete-profile-role",
    GET_PROFILE_ROLE: PORT_URL + "/api/permission/get-profile-role",
    GET_PROFILE_ROLES: PORT_URL + "/api/permission/get-profile-roles",
    GET_AVAILABLE_PROFILE_ROLES: PORT_URL + "/api/permission/get-available-profile-roles",
    SEED_PERMISSIONS: PORT_URL + "/api/permission/seed-permissions",
    GET_MY_PERMISSIONS: PORT_URL + "/api/permission/my-permissions",
    
    CREATE_INVITATION: PORT_URL + "/api/invitation/create",
    GET_INVITATIONS: PORT_URL + "/api/invitation/list",
    GET_TEAM_MEMBERS: PORT_URL + "/api/invitation/team-members",
    RESEND_INVITATION: PORT_URL + "/api/invitation/resend",
    CANCEL_INVITATION: PORT_URL + "/api/invitation/cancel",
    DELETE_INVITATION: PORT_URL + "/api/invitation/delete",
    VALIDATE_INVITATION: PORT_URL + "/api/invitation/validate",
    ACCEPT_INVITATION: PORT_URL + "/api/invitation/accept",
    GET_AVAILABLE_ROLES: PORT_URL + "/api/invitation/available-roles",
    UPDATE_MEMBER_ROLE: PORT_URL + "/api/invitation/update-member-role",
    RESET_MEMBER_PASSWORD: PORT_URL + "/api/invitation/reset-member-password",
    
    GET_DASHBOARD_FULL: PORT_URL + "/api/dashboard/full",
    GET_DASHBOARD_METRICS: PORT_URL + "/api/dashboard/metrics",
    GET_DASHBOARD_APPROVAL_COUNTS: PORT_URL + "/api/dashboard/approval-counts",
    GET_DASHBOARD_TOP_CUSTOMERS: PORT_URL + "/api/dashboard/top-customers",
    GET_DASHBOARD_HIRING_TREND: PORT_URL + "/api/dashboard/hiring-trend",
    GET_DASHBOARD_ROLE_DISTRIBUTION: PORT_URL + "/api/dashboard/role-distribution",

    PARTNER_RELATION_ADD: PORT_URL + "/api/partner-relation/add",
    PARTNER_RELATION_INVITE: PORT_URL + "/api/partner-relation/invite",
    PARTNER_RELATION_MY_PARTNERS: PORT_URL + "/api/partner-relation/my-partners",
    PARTNER_RELATION_MY_CLIENTS: PORT_URL + "/api/partner-relation/my-clients",
    PARTNER_RELATION_PARTNER_STATS: PORT_URL + "/api/partner-relation/partner-stats",
    PARTNER_RELATION_CLIENT_STATS: PORT_URL + "/api/partner-relation/client-stats",
    PARTNER_RELATION_REMOVE: PORT_URL + "/api/partner-relation",
    PARTNER_RELATION_RESEND_INVITE: PORT_URL + "/api/partner-relation/resend-invite",
    PARTNER_RELATION_CANCEL_INVITE: PORT_URL + "/api/partner-relation/cancel-invite",
    PARTNER_RELATION_VALIDATE_TOKEN: PORT_URL + "/api/partner-relation/validate-token",
    PARTNER_RELATION_REGISTER_AND_ACCEPT: PORT_URL + "/api/partner-relation/register-and-accept",
    PARTNER_RELATION_BENCH_POOL: PORT_URL + "/api/partner-relation",
    PARTNER_RELATION_ACCEPT: PORT_URL + "/api/partner-relation/accept",
    PARTNER_RELATION_DECLINE: PORT_URL + "/api/partner-relation/decline",
    GET_OFFLINE_PARTNER_SETTINGS: PORT_URL + "/api/partner-relation/offline-settings",
    UPDATE_OFFLINE_PARTNER_SETTINGS: PORT_URL + "/api/partner-relation/offline-settings",
    GET_APPLICATION_TALENT_IDS: PORT_URL + "/api/get-application-talent-ids",

    HELP_LIST_CATEGORIES: PORT_URL + "/api/help/categories",
    HELP_CREATE_CATEGORY: PORT_URL + "/api/help/categories",
    HELP_UPDATE_CATEGORY: PORT_URL + "/api/help/categories",
    HELP_DELETE_CATEGORY: PORT_URL + "/api/help/categories",
    HELP_LIST_ITEMS: PORT_URL + "/api/help/items/list",
    HELP_SEARCH_ITEMS: PORT_URL + "/api/help/items/search",
    HELP_GET_ITEM: PORT_URL + "/api/help/items",
    HELP_CREATE_ITEM: PORT_URL + "/api/help/items",
    HELP_UPDATE_ITEM: PORT_URL + "/api/help/items",
    HELP_DELETE_ITEM: PORT_URL + "/api/help/items",
    HELP_GENERATE_CONTENT: PORT_URL + "/api/help/generate-content",
    HELP_GET_STATS: PORT_URL + "/api/help/stats",
    HELP_SEED: PORT_URL + "/api/help/seed",

    ROLE_PRICING: PORT_URL + "/api/role-pricing",
    ROLE_PRICING_CHECK: PORT_URL + "/api/role-pricing/check",
    ROLE_PRICING_RECOMMENDATION: PORT_URL + "/api/role-pricing/recommendation",
    ROLE_PRICING_TEMPLATE: PORT_URL + "/api/role-pricing/template",
    ROLE_PRICING_BULK_UPLOAD: PORT_URL + "/api/role-pricing/bulk-upload",
    ROLE_PRICING_REFERENCE_VALUES: PORT_URL + "/api/role-pricing/reference-values",
    SEED_REFERENCE_VALUES: PORT_URL + "/api/role-pricing/seed-reference-values",
    ROLE_PRICING_SEED_ROLES: PORT_URL + "/api/role-pricing/seed-roles",
    ROLE_PRICING_ROLE_NAMES: PORT_URL + "/api/role-pricing/role-names",
    ROLE_PRICING_CUSTOM_ROLE: PORT_URL + "/api/role-pricing/custom-role",

    BRANDED_RESUME_BASE: PORT_URL + "/api/talent",
    TALENT_JOB_MATCHES: PORT_URL + "/api/talent",
    EXTRACT_TALENT_DOCUMENT: PORT_URL + "/api/extract-talent-document",
    EXTRACT_DOCUMENT_FROM_PATH: PORT_URL + "/api/extract-document-from-path",
    UPLOAD_DOCUMENT_WITH_OCR: PORT_URL + "/api/upload-document",
    GET_VERIFICATION_LIST: PORT_URL + "/api/verification-list",
    VERIFY_TALENT: PORT_URL + "/api/verify",
    GET_MATCHED_TALENTS: PORT_URL + "/api/matched-talents",
    POST_MATCHED_COUNTS: PORT_URL + "/api/matched-counts",
    BULK_UPLOAD_TEMPLATE: PORT_URL + "/api/bulk-upload-template",
    BULK_UPLOAD_JOBS: PORT_URL + "/api/bulk-upload-jobs",
    LOCATIONS_COUNTRIES: PORT_URL + "/api/locations/countries",
    LOCATIONS_CITIES: PORT_URL + "/api/locations/cities",
    LOCATIONS_COUNTRY: PORT_URL + "/api/locations/countries",
    LOCATIONS_CITY: PORT_URL + "/api/locations/cities",
    CREATE_INTERVIEW_REQUEST: PORT_URL + "/api/interview-request",
    GET_INTERVIEW_REQUESTS: PORT_URL + "/api/interview-requests",
    ACCEPT_INTERVIEW_REQUEST: PORT_URL + "/api/interview-request",
    REJECT_INTERVIEW_REQUEST: PORT_URL + "/api/interview-request",
    GET_INTERVIEW_REQUEST_STATUS: PORT_URL + "/api/interview-request-status",

    COMPLIANCE_TEMPLATES: PORT_URL + "/api/compliance-templates",
    COMPLIANCE_DOCUMENTS_LIST: PORT_URL + "/api/compliance-documents/list",
    COMPLIANCE_DOCUMENTS: PORT_URL + "/api/compliance-documents",
    COMPLIANCE_GENERATE: PORT_URL + "/api/compliance-documents/generate",
    COMPLIANCE_BACKFILL_ALL: PORT_URL + "/api/compliance-documents/backfill-all",

    NOTIFICATIONS: PORT_URL + "/api/notifications",
    NOTIFICATIONS_UNREAD_COUNT: PORT_URL + "/api/notifications/unread-count",
    NOTIFICATIONS_MARK_READ: PORT_URL + "/api/notifications/:id/read",
    NOTIFICATIONS_READ_ALL: PORT_URL + "/api/notifications/read-all",

    BENCH_SHARE_BASE: PORT_URL + "/api/bench-share",
    BENCH_SHARE_PUBLIC: PORT_URL + "/api/public/bench",
    EXPORT_BENCH_POOL: PORT_URL + "/api/export-bench-pool",
    REFERRAL_MY_CODE: PORT_URL + "/api/referrals/my-code",
    REFERRAL_REFERRED_CUSTOMERS: PORT_URL + "/api/referrals/referred-customers",
    REFERRAL_BY_PARTNER: PORT_URL + "/api/referrals/by-partner",
    REFERRAL_ALL_PARTNERS: PORT_URL + "/api/referrals/all-partners",

    PERFORMANCE_FEEDBACK: PORT_URL + "/api/performance-feedback",
    PERFORMANCE_FEEDBACK_TALENT_SUMMARY: PORT_URL + "/api/performance-feedback/talent-summary",
    PERFORMANCE_FEEDBACK_HIRING_RECORD: PORT_URL + "/api/performance-feedback/hiring-record",
    PERFORMANCE_FEEDBACK_TALENT: PORT_URL + "/api/performance-feedback/talent",
    PERFORMANCE_FEEDBACK_STATS: PORT_URL + "/api/performance-feedback/stats",
    PERFORMANCE_FEEDBACK_RESOLVE: PORT_URL + "/api/performance-feedback",
    PERFORMANCE_FEEDBACK_EXPORT: PORT_URL + "/api/performance-feedback/export",
});
